
export default function BoltJourney({data}) {
  return (
    <>
      <section className="bolt-journey-area">
        <img src={data && data.vector} alt="vector" className="img-responsive bolt-journey-vec" loading="lazy"/>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="bolt-journey-head">
                <h3 className="heading center-heading">{data && data.titlePart1} <span className='gradiant-color'>{data && data.titlePart2}</span></h3>
                <p className='sub-heading'>{data && data.description}</p>
              </div>
            </div>
          </div>
        </div>
        <img src={data && data.image} alt="journey" className="img-responsive bolt-journey-img" loading="lazy"/>
      </section>
    </>
  )
}
